import {IConfig} from '../core/interfaces/reducers'
const search = location.search.substring(1)
let queryObject: Record<string, string> = {}
if (search) {
  queryObject = JSON.parse(
    '{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
  )
}

const xyApiUrl = process.env.HOST_API_URL
const geoserverApiUrl = process.env.GEOSERVER_URL

const appConfig = {
  isPublic: (window as any).appType == 'public' || queryObject['app'] == 'public',
  admin: (window as any).appType == 'admin' || queryObject['app'] == 'admin',
  isCad: (window as any).appType == 'cad' || queryObject['app'] == 'cad',
  isCadPlan: (window as any).appType == 'misc' || queryObject['app'] == 'misc',
  isReg: (window as any).appType == 'reg' || queryObject['app'] == 'reg',
  isUnd: (window as any).appType == 'underground' || queryObject['app'] == 'underground',
  isOUP: (window as any).appType == 'oup' || queryObject['app'] == 'oup',
  isArchImport: (window as any).appType == 'arch.import' || queryObject['app'] == 'arch.import',
  nomenclaturesUrl: xyApiUrl + '/Nomenclatures/GetNomenclatures',
  common: {
    settlements: {
      settlementsUrl: xyApiUrl + '/Common/Settlement'
    },
    locations: {
      locationsUrl: xyApiUrl + '/Common/Locality'
    }
  },
  properties: {
    Properties: {
      url: xyApiUrl + '/PropertyMgmt/Properties'
    }
  },
  misc: {
    MiscPoint: {
      url: xyApiUrl + '/Misc/MiscPoint'
    },
    MiscLine: {
      url: xyApiUrl + '/Misc/MiscLine'
    },
    Visas: {
      url: xyApiUrl + '/Misc/Visas'
    },
    MovableObjects: {
      url: xyApiUrl + '/Misc/MovableObjects'
    },
    miscrelated: [
      xyApiUrl + '/Misc/MiscPoint',
      xyApiUrl + '/Misc/MiscLine',
      xyApiUrl + '/Misc/Visas',
      xyApiUrl + '/Misc/MovableObjects'
    ]
  },
  oup: {
    ouprelated: [xyApiUrl + '/OUP/Zone', xyApiUrl + '/OUP/Project']
  },
  crosses: {
    c70k3: {
      url: xyApiUrl + '/Crosses/c70k3'
    },
    c70k5: {
      url: xyApiUrl + '/Crosses/c70k5'
    },
    c70k7: {
      url: xyApiUrl + '/Crosses/c70k7'
    },
    c70k9: {
      url: xyApiUrl + '/Crosses/c70k9'
    },
    c50324: {
      url: xyApiUrl + '/Crosses/c50324'
    },
    c50327: {
      url: xyApiUrl + '/Crosses/c50327'
    },
    c50621: {
      url: xyApiUrl + '/Crosses/c50621'
    },
    c50627: {
      url: xyApiUrl + '/Crosses/c50627'
    },
    c3024: {
      url: xyApiUrl + '/Crosses/c3024'
    },
    c3027: {
      url: xyApiUrl + '/Crosses/c3027'
    }
  },
  cadastre: {
    schema: {
      url: geoserverApiUrl + '/MapAccess_CMCRApartmentWMS/0'
    },
    immovable: {
      url: geoserverApiUrl + '/MapAccess_CMCRImmovableWMS/0'
    },
    building: {
      url: geoserverApiUrl + '/MapAccess_CMCRBuildingWMS/0'
    }
  },
  streetreg: {
    points: {
      url: xyApiUrl + '/StreetReg/StreetRegPoint'
    },
    troto: {
      url: xyApiUrl + '/StreetReg/StreetRegLine'
    },
    os: {
      url: xyApiUrl + '/StreetReg/StreetRegOsLine'
    },
    area: {
      url: xyApiUrl + '/StreetReg/StreetRegArea'
    },
    arealines: {
      url: xyApiUrl + '/StreetReg/StreetRegAreaLine'
    },
    streetplan: {
      url: xyApiUrl + '/StreetReg/StreetRegPlan'
    }
  },
  reg: {
    traspoints: {
      url: xyApiUrl + '/Reg/PlanPrintCoordinate'
    },
    measures: {
      url: xyApiUrl + '/Reg/Measures'
    },
    cadPreviewLine: {
      url: xyApiUrl + '/Reg/cadPreviewLine'
    },
    cadPreviewContur: {
      url: xyApiUrl + '/Reg/cadPreviewContur'
    },
    cadPreviewText: {
      url: xyApiUrl + '/Reg/cadPreviewText'
    },

    perpeniculars: {
      url: xyApiUrl + '/Reg/Perpendiculars'
    },
    endrego: {
      url: xyApiUrl + '/Reg/EndRego'
    },
    parcels: {
      parcelsUrl: xyApiUrl + '/Reg/Parcel'
    },
    quarters: {
      quartersUrl: xyApiUrl + '/Reg/Quarter'
    },
    plan: {
      planUrl: xyApiUrl + '/Reg/RegPlan'
    },
    regPoint: {
      id: xyApiUrl + '/Reg/RegPoint'
    },
    regLine: {
      id: xyApiUrl + '/Reg/RegLine'
    },
    regOsLine: {
      id: xyApiUrl + '/Reg/RegOsLine'
    },
    siteLine: {
      id: xyApiUrl + '/Reg/SiteLine'
    },
    site: {
      id: xyApiUrl + '/Reg/Site'
    },
    streetreg: {
      id: xyApiUrl + '/Reg/StreetUnregulatedReg'
    },
    matrixZone: {
      ids: [xyApiUrl + '/Reg/MatrixZone#1', xyApiUrl + '/Reg/MatrixZone#2', xyApiUrl + '/Reg/MatrixZone#3'],
      mainLayerId: xyApiUrl + '/Reg/MatrixZone'
    },
    regrelated: [
      xyApiUrl + '/Reg/Parcel',
      xyApiUrl + '/Reg/Quarter',
      xyApiUrl + '/Reg/RegPoint',
      xyApiUrl + '/Reg/RegOsLine',
      xyApiUrl + '/Reg/RegLine',
      xyApiUrl + '/Reg/SiteLine',
      xyApiUrl + '/Reg/EndRego',
      xyApiUrl + '/Reg/RegGreenLine'
    ]
  },
  und: {
    shaft: {
      shaftUrl: xyApiUrl + '/UND/Shaft'
    },
    productPipeline: {
      productPipelineUrl: xyApiUrl + '/UND/ProductPipeline'
    },
    powerline: {
      powerlineUrl: xyApiUrl + '/UND/PowerLine'
    },
    duct: {
      ductUrl: xyApiUrl + '/UND/Duct'
    },
    undrelated: [
      xyApiUrl + '/UND/Shaft',
      xyApiUrl + '/UND/ProductPipeline',
      xyApiUrl + '/UND/PowerLine',
      xyApiUrl + '/UND/Duct'
    ]
  },
  archImport: {
    plan: {
      url: xyApiUrl + '/ArchImport/ArchPlan'
    },
    planHistory: {
      url: xyApiUrl + '/ArchImport/ArchPlanHistory'
    }
  },
  ISettlementRelated: [
    xyApiUrl + '/UND/Duct',
    xyApiUrl + '/UND/PowerLine',
    xyApiUrl + '/UND/ProductPipeline',
    xyApiUrl + '/UND/Shaft',
    xyApiUrl + '/Property/Properties'
  ],
  regimport: {
    regimportUrl1: xyApiUrl + '/RegImport1',
    regimportUrl2: xyApiUrl + '/RegImport2',
    regimportUrl3: xyApiUrl + '/RegImport3',
    importReg: xyApiUrl + '/ImportReg',
    regImportGetFileUrl: xyApiUrl + '/RegImportFiles'
  },
  constrImport: {
    constimportUrl1: xyApiUrl + '/ConstructionImport1',
    constimportUrl2: xyApiUrl + '/ConstructionImport2',
    importReg: xyApiUrl + '/ConstructionImport',
    constImportGetFileUrl: xyApiUrl + '/RegImportFiles'
  },
  editsImport: {
    validate: xyApiUrl + '/EditsImportValidate',
    import: xyApiUrl + '/EditsImport'
  }
}
if (appConfig.isPublic) {
  appConfig.isCad = true
  appConfig.isOUP = true
  appConfig.isReg = true
  // appConfig.isCadPlan = true
  // appConfig.isUnd = true
}
if (appConfig.isCad || appConfig.isOUP || appConfig.isReg || appConfig.isUnd || appConfig.isArchImport) {
  appConfig.admin = false
}
type ILocalConfig = typeof appConfig

type IAppConfig = ILocalConfig & IConfig

export default appConfig as IAppConfig
